import React, {useContext, useState} from "react";
import {REFETCH_OPTIONS, useGetAllArticles, useGetArticles} from "../../../services/ContentManager";
import {ARTICLES, getErrorMessage, put} from "../../../services/Client";
import {UserContext} from "../../App";
import CircularLoading from "../../../components/CircularLoading";
import {isAdmin as getIsAdmin} from "../../../services/PermissionManager";
import {useQueryClient} from "react-query";
import {useSnackbar} from "notistack";
import {ARTICLE_ROUTE} from "../../../constants/vendors";
import { useHistory } from "react-router-dom";
import {useTranslation} from "react-i18next";
import ArticleList from "../../../components/VendorComponents/ArticleList";
import BoxedResponsiveText from "components/BoxedResponsiveText";
import WarningIcon from "@mui/icons-material/Warning";
import { ARTICLE_HISTORY_SUFFIX, BASE_ARTICLE_ROUTE, ALL_ARTICLES_ROUTE } from "containers/Articles/AdminArticlesRoutes";
import { responsiveWidth } from "services/useBreakpoint";

const storageKey = "articles-table-columns";

export default function Articles({uid, urlPrefix = ''}) {
    let queryClient = useQueryClient();
    const {enqueueSnackbar} = useSnackbar();
    let history = useHistory();
    const {t} = useTranslation();
    let isAdmin = getIsAdmin(useContext(UserContext));
    let { articles, status } = useArticlesByRole(uid, isAdmin)
    const { articleHistory } = createArticleHistoryRoute(history, isAdmin, urlPrefix);
    const { editArticle, editVisible } = createArticleEditFunctions({ history, urlPrefix, uid, enqueueSnackbar, queryClient, t })

    if (status === 'loading')
        return <CircularLoading/>

    return (
        <React.Fragment>
            {
                !isAdmin 
                &&
                <BoxedResponsiveText
                color="#92400e"
                align="center"
                sx={{
                    justifySelf: 'center',
                    padding: '10px',
                    background: "#fef3c7",
                    maxWidth: '80%',
                    gap: 1,
                    alignItems: 'center',
                    display:'flex'
                }}
                >
                <WarningIcon sx={{color: 'orange'}}/>
                <React.Fragment>
                    {t('infoCommunityPrizes')}
                </React.Fragment>
                </BoxedResponsiveText>
            }
            <ArticleList articles={articles} articleHistory={articleHistory}
                editArticle={editArticle}
                editVisible={editVisible} disabled={isAdmin} additionalColumns={createAdditionalColumns({ isAdmin, t })} />
        </React.Fragment>
    )

}

function useArticlesByRole(uid, isAdmin) {

    const { articles: vendorArticles, status: vendorArticlesStatus } = useGetArticles(uid);
    const { articles: allArticles, status: allArticlesStatus } = useGetAllArticles({ isAdmin, refetchOptions: REFETCH_OPTIONS });

    return isAdmin
        ? { articles: allArticles, status: allArticlesStatus }
        : { articles: vendorArticles, status: vendorArticlesStatus };
}

function createArticleHistoryRoute(history, isAdmin, urlPrefix) {
    return {
        articleHistory: (id) => {
            const vendorArticleHistoryRoute = urlPrefix + ARTICLE_ROUTE + (id || '') + '/history';
            const adminArticleHistoryRoute = `${ALL_ARTICLES_ROUTE}/${BASE_ARTICLE_ROUTE}/${id || ''}/${ARTICLE_HISTORY_SUFFIX}`
            history.push(
                isAdmin
                    ? adminArticleHistoryRoute
                    : vendorArticleHistoryRoute
            );
        }
    };
}

function createArticleEditFunctions({ history, urlPrefix, uid, enqueueSnackbar, queryClient, t }) {
    return {
        editArticle: (id) => {
            const vendorEditRoute = urlPrefix + ARTICLE_ROUTE + (id || '');
            history.push(vendorEditRoute);
        },
        editVisible: (id, field, value, row) => {
            enqueueSnackbar(t('saving...'), { variant: "info" });
            put(`${ARTICLES}/${id}/updateVisible`, { body: { [field]: value, shopId: row.shopId } })
                .then(() => {
                    enqueueSnackbar(t('saved'), { variant: "success" });
                })
                .catch(e => enqueueSnackbar(getErrorMessage(e), { variant: "error" }))
                .finally(() => queryClient.invalidateQueries([ARTICLES, { uid: uid }]));
        }
    }
}

function createAdditionalColumns({isAdmin, t}) {
    if(!isAdmin)
        return [];

    return [
        {
            headerName: t('shopId'),
            field: 'shopId',
            width: responsiveWidth({ viewWidth: 14, minWidth: 90 }),
        },
        {
            headerName: t('shopName'),
            field: 'shopName',
            width: responsiveWidth({ viewWidth: 14, minWidth: 90 }),
        },
        {
            headerName: t('iban'),
            field: 'shopIban',
            width: responsiveWidth({ viewWidth: 14, minWidth: 'auto' }),            
        }
    ]
    

}



